// This file is auto-generated by @hey-api/openapi-ts
import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  GetCustomApiConfigurationCfgIonLineNewData,
  GetCustomApiConfigurationDocumentBySessionIdPdfData,
  GetCustomApiConfigurationDocumentBySessionIdPdfResponse,
  GetCustomApiConfigurationFachhaendlerByFhIdentData,
  GetCustomApiConfigurationFachhaendlerByFhIdentResponse,
  GetCustomApiConfigurationInfoResponse,
  GetCustomApiHelloWorldResponse,
  PostCustomApiConfigurationMailData,
  PostCustomApiConfigurationMailResponse,
} from "./types.gen";

export class ConfigurationService {
  /**
   * Redirects to an initialised configurator session for a CFG_ION_LINE
   * localeId: de-DE
   * currencyId: EUR
   * sortiment: DE
   * @param data The data for the request.
   * @param data.localeId Configurator locale (de-DE)
   * @param data.currencyId
   * @param data.sortiment Sortiment identifier used in configuration
   * @param data.fhIdent Fachhaendler Ident
   * @throws ApiError
   */
  public static getCustomApiConfigurationCfgIonLineNew(
    data: GetCustomApiConfigurationCfgIonLineNewData = {},
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/configuration/CFG_ION_LINE/new",
      query: {
        localeId: data.localeId,
        currencyId: data.currencyId,
        sortiment: data.sortiment,
        fhIdent: data.fhIdent,
      },
      errors: {
        301: "Moved Permanently",
        500: "Internal Server Error",
      },
    });
  }

  /**
   * Sends a quote request e-mail from the customer.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown OK
   * @throws ApiError
   */
  public static postCustomApiConfigurationMail(
    data: PostCustomApiConfigurationMailData = {},
  ): CancelablePromise<PostCustomApiConfigurationMailResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/custom/api/configuration/mail",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Generate configuration document download.
   * Example
   *
   * sessionId: 123
   * localeId: de-DE
   * @param data The data for the request.
   * @param data.sessionId Session ID
   * @param data.localeId Configurator locale (de-DE)
   * @returns unknown OK
   * @throws ApiError
   */
  public static getCustomApiConfigurationDocumentBySessionIdPdf(
    data: GetCustomApiConfigurationDocumentBySessionIdPdfData,
  ): CancelablePromise<GetCustomApiConfigurationDocumentBySessionIdPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/configuration/document/{sessionId}/pdf",
      path: {
        sessionId: data.sessionId,
      },
      query: {
        localeId: data.localeId,
      },
    });
  }

  /**
   * Get Fachhaendler information for a given configuration session.
   * Example
   * fhIdent: CHE6315UKN01
   * lang: DE
   * country: DE
   * @param data The data for the request.
   * @param data.fhIdent Fachhaendler Ident
   * @param data.lang Language Id
   * @param data.country Country Code
   * @returns unknown OK
   * @throws ApiError
   */
  public static getCustomApiConfigurationFachhaendlerByFhIdent(
    data: GetCustomApiConfigurationFachhaendlerByFhIdentData,
  ): CancelablePromise<GetCustomApiConfigurationFachhaendlerByFhIdentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/configuration/fachhaendler/{fhIdent}",
      path: {
        fhIdent: data.fhIdent,
      },
      query: {
        lang: data.lang,
        country: data.country,
      },
    });
  }

  /**
   * Get API version information from the configuration server.
   * @returns unknown OK
   * @throws ApiError
   */
  public static getCustomApiConfigurationInfo(): CancelablePromise<GetCustomApiConfigurationInfoResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/configuration/info",
    });
  }

  /**
   * Hello world for testing and healh checks
   * @returns unknown OK
   * @throws ApiError
   */
  public static getCustomApiHelloWorld(): CancelablePromise<GetCustomApiHelloWorldResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/custom/api/helloWorld",
    });
  }
}
